import styles from './HeroBanner.module.scss';
import clsx from 'clsx';
import Button from '../../atoms/button';
import React from 'react';

// TODO: to be removed after button update
const Icon = () => {
  return (
    <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.1 23.8">
      <path
        class="cls-1"
        d="M36.6,1.4A4.76,4.76,0,0,0,33.2,0H4.7A4.76,4.76,0,0,0,1.3,1.4,4.67,4.67,0,0,0,0,4.8V19a4.78,4.78,0,0,0,4.8,4.8H33.3A4.78,4.78,0,0,0,38.1,19V4.8A5.32,5.32,0,0,0,36.6,1.4ZM37,19a4,4,0,0,1-1.1,2.7,3.86,3.86,0,0,1-2.7,1.1H4.7A4,4,0,0,1,2,21.7,3.86,3.86,0,0,1,.9,19V4.8A4,4,0,0,1,2,2.1,3.86,3.86,0,0,1,4.7,1H33.2a4,4,0,0,1,2.7,1.1A3.86,3.86,0,0,1,37,4.8Z"
      />
      <path
        class="cls-1"
        d="M10.7,10.2a.85.85,0,0,0,0-.7.86.86,0,0,0-.3-.6,1.61,1.61,0,0,0-.7-.4,2.2,2.2,0,0,0-.8-.1H6.8c-.1,0-.1,0-.2.1s-.1.1-.1.2L5.7,14v.2c0,.1,0,0,.1,0H6.9c.1,0,.1,0,.2-.1l.1-.1.2-1.4c0-.1,0-.1.1-.2s.1-.1.2-.1h.7a2.77,2.77,0,0,0,.9-.1,3,3,0,0,0,.8-.4,1.79,1.79,0,0,0,.5-.7A2.77,2.77,0,0,0,10.7,10.2ZM8,11.1H7.7l.2-1.4V9.6h.2c.4,0,.7,0,.9.2a.37.37,0,0,1,.1.3c.1,0,.1.1.1.2C9.1,11.1,8.5,11.1,8,11.1Z"
      />
      <path
        class="cls-1"
        d="M32.2,8.4l-.1-.1H31l-.1.1-.8,5.4V14h1.1c.1,0,.1,0,.2-.1s.1-.1.1-.2l.8-5.3C32.3,8.5,32.3,8.5,32.2,8.4Z"
      />
      <path
        class="cls-1"
        d="M20.5,10.3l-.1-.1H19.3l-.1.1-1.4,2-.6-2c0-.1-.1-.1-.1-.2a.35.35,0,0,0-.2-.1H15.8l-.1.1v.2l1.1,3.2-1,1.5v.2a.1.1,0,0,0,.1.1h1.2l.1-.1,3.3-4.8Z"
      />
      <path
        class="cls-1"
        d="M30,10.3l-.1-.1v.1H28.8l-.1.1v.3l-.1-.1a.55.55,0,0,0-.5-.3,1.27,1.27,0,0,0-.6-.1,2.2,2.2,0,0,0-1.5.6,2.1,2.1,0,0,0-.7,1.4,2.15,2.15,0,0,0,0,.8,1.61,1.61,0,0,0,.4.7,2.09,2.09,0,0,0,.6.4,1.7,1.7,0,0,0,.7.1,1.48,1.48,0,0,0,.7-.1,2.09,2.09,0,0,0,.6-.4v.5c0,.1,0,0,.1,0h1c.1,0,.1,0,.2-.1s.1-.1.1-.2l.5-3.5C30,10.4,30,10.4,30,10.3Zm-1.6,1.9a.91.91,0,0,1-.3.7,1.14,1.14,0,0,1-.8.3.76.76,0,0,1-.4-.1c-.1,0-.2-.1-.3-.2s-.1-.2-.2-.3v-.4a1,1,0,0,1,.4-.7,1.08,1.08,0,0,1,.7-.3.76.76,0,0,1,.4.1c.1,0,.2.1.3.2s.1.2.2.3Z"
      />
      <path
        class="cls-1"
        d="M15.2,10.2H14l-.1.1v.3l-.1-.1c-.2-.2-.3-.3-.5-.3a1.27,1.27,0,0,0-.6-.1,2.2,2.2,0,0,0-1.5.6,2.1,2.1,0,0,0-.7,1.4,2.15,2.15,0,0,0,0,.8,1.61,1.61,0,0,0,.4.7,1.27,1.27,0,0,0,.6.4,1.7,1.7,0,0,0,.7.1,1.48,1.48,0,0,0,.7-.1,2.09,2.09,0,0,0,.6-.4v.5h1.1c.1,0,.1,0,.2-.1s.1-.1.1-.2l.5-3.4v-.2A.14.14,0,0,1,15.2,10.2Zm-1.9,2.7a1.14,1.14,0,0,1-.8.3.76.76,0,0,1-.4-.1c-.1,0-.2-.1-.3-.2s-.1-.2-.2-.3v-.4a1,1,0,0,1,.4-.7,1.08,1.08,0,0,1,.7-.3.76.76,0,0,1,.4.1c.1,0,.2.1.3.2s.1.2.2.3v.4C13.7,12.5,13.6,12.7,13.3,12.9Z"
      />
      <path
        class="cls-1"
        d="M25.4,9.5a.86.86,0,0,0-.3-.6,1.61,1.61,0,0,0-.7-.4,2.2,2.2,0,0,0-.8-.1H21.5c-.1,0-.1,0-.2.1s-.1.1-.1.2L20.4,14v.2h1.4l.1-.1.2-1.5c0-.1,0-.1.1-.2s.1-.1.2-.1H23a2.77,2.77,0,0,0,.9-.1,3,3,0,0,0,.8-.4,1.79,1.79,0,0,0,.5-.7,2.92,2.92,0,0,0,.2-.9Zm-1.5.8c-.1.8-.7.8-1.2.8h-.3l.2-1.4a.1.1,0,0,1,.1-.1h.2c.4,0,.7,0,.9.2a.37.37,0,0,1,.1.3Z"
      />
    </svg>
  );
};

export const TeaserButtons = ({ teasers, renderButton, buttonShouldBeInverted }) => {
  if (!teasers && !Array.from(teasers).length) {
    return teasers[0].buttonUrl && teasers[0].buttonTitle && renderButton(teasers[0]);
  }

  return (
    <div className={teasers?.length > 1 ? styles.buttonGroup : styles.buttonGroupSingle}>
      {Array.from(teasers).map((teaser, key) => {
        const teaserButtons = teaser.buttons?.length
          ? teaser.buttons
          : (teaser.buttonUrl && [
              {
                buttonType: teaser.buttonType,
                buttonUrl: teaser.buttonUrl,
                buttonTitle: teaser.buttonTitle,
              },
            ]) ||
            [];

        if (!teaserButtons.length || !teaserButtons.find((btn) => btn.buttonTitle)) {
          return null;
        }

        return (
          teaserButtons?.length && (
            <div
              key={`buttonHolder_${key}`}
              className={clsx(
                styles.buttonHolder,
                styles[`horizontalPosition__center`],
                styles[`verticalPosition__center`],
                { [styles.isSingleBtn]: teaserButtons?.length === 1 },
              )}
            >
              {teaserButtons.map((btn, index) => {
                if (!btn.buttonTitle) return null;
                return (
                  <Button
                    key={`button_${index}`}
                    variant={btn.buttonType}
                    isOutlined={false}
                    as={btn.buttonType === 'text' ? 'text' : 'link'}
                    nodeLink={btn.buttonUrl}
                    ariaLabel={btn.buttonTitle}
                    isInverted={buttonShouldBeInverted}
                    className={clsx(styles.heroButton, styles[btn.buttonType], {
                      [styles.inverted]: buttonShouldBeInverted,
                    })}
                  >
                    {btn.buttonTitle}
                  </Button>
                );
              })}
            </div>
          )
        );
      })}
    </div>
  );
};
